import { Col, Row } from 'antd';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { SpotifyVerifiedBadge } from '../../../../AboutArtist';

export function DetailsCard(props: { title: string; children: any; extra?: any }) {
  const { title, children, extra } = props;
  return (
    <div className='now-playing-card'>
      <div className='title-section'>
        <div className='title'>{title}</div>
        {extra}
      </div>
      <div>{children}</div>
    </div>
  );
}

interface ArtistsCardProps {
  id: string;
  title: string;
  extra?: any;
  children?: any;
  image?: string;
  subtitle?: string;
  imageTitle?: string;
  verified?: boolean;
  monthlyListeners?: number;
  bioSnippet?: string;
  onClick?: () => void;
}

export function ArtistsCard(props: ArtistsCardProps) {
  return (
    <div
      className='artist-playing-now-card'
      onClick={props.onClick}
      style={{
        cursor: 'pointer',
        overflow: 'hidden',
        transition: 'background-color 0.2s ease, transform 0.2s ease',
      }}
    >
      {props.image ? (
        <div
          className='playing-now-card-image'
          style={{
            maxHeight: 200,
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 60%), url("${props.image}")`,
          }}
        >
          <div className='playing-now-card-image-text'>
            <div data-encore-id='text'>
              <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#fff' }}>
                {props.imageTitle || 'About the artist'}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className='playing-now-card-text' style={{ padding: '16px', position: 'relative', minWidth: 0 }}>
        {/* Artist Name + Verified Badge */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%', minWidth: 0, marginBottom: 4 }}>
          <Link
            to={`/artist/${props.id?.includes(':') ? props.id.split(':').reverse()[0] : props.id}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className='artist-playing-now-name-link'
            style={{
              color: '#ffffff',
              fontWeight: 700,
              fontSize: '1.05rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            {props.title}
          </Link>
          {props.verified !== false && <SpotifyVerifiedBadge size={17} />}
        </div>

        {/* Monthly Listeners + Follow Button */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', minWidth: 0, marginTop: 4 }}>
          <div style={{ color: '#b3b3b3', fontSize: '0.875rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {props.monthlyListeners ? `${props.monthlyListeners.toLocaleString()} monthly listeners` : props.subtitle}
          </div>
          {props.extra ? (
            <div
              onClick={(e) => e.stopPropagation()}
              style={{ flexShrink: 0, marginLeft: 12 }}
            >
              {props.extra}
            </div>
          ) : null}
        </div>

        {/* Bio Snippet */}
        {props.bioSnippet ? (
          <div
            style={{
              marginTop: 12,
              color: '#b3b3b3',
              fontSize: '0.875rem',
              lineHeight: 1.5,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {props.bioSnippet}
          </div>
        ) : null}
      </div>
    </div>
  );
};
